export const FORGETRUST = {
  EMAIL: 'info@forgetrust.com',
  PHONE: '1-800-248-8447',
  WELCOME_EMAIL: 'welcome@forgetrust.com',
  MAIN_DISCLAIMER:
    'Forge Trust Co. is a self-directed custodian and does not provide due diligence or tax, legal, or investment advice to third parties regarding prospective investments, platforms, sponsors, dealers, or service providers. Forge Trust Co. and its representatives are not a fiduciary under ERISA and do not sell investments or evaluate, recommend, or endorse any advisory firm or investments. Investments are not FDIC insured and are subject to risk, including the loss of principal. The information contained herein is for informational purposes only. Prior to making any investment decisions, each person is advised to perform his or her own due diligence and consult with a personal tax representative, financial planner, attorney, or accountant with respect to such individual’s specific situation.',
};

export const LEGAL_LINKS = {
  TERMS_OF_USE: 'https://forgetrust.com/download/terms-and-conditions/',
  PRIVACY_POLICY: 'https://forgetrust.com/download/privacy-notice/',
  DISCLOSURES:
    'https://privacyportal-cdn.onetrust.com/dsarwebform/4746f8bd-56c1-4453-8c4c-7e764ebc8606/99439af6-23d5-4a61-af1e-413f75776bdd.html',
};

export const VALUATION_FORM_LINKS = {
  IRA_LLC: 'https://forgetrust.com/forms/valuation-for-llc-individual-family/',
  REAL_ESTATE: 'https://forgetrust.com/forms/valuation-for-real-estate/',
  IRA_ASSET: 'https://forgetrust.com/forms/valuation-for-other-ira-assets/',
};

export const MARITAL_STATUS = [
  {
    label: 'Single',
    value: 'Single',
  },
  {
    label: 'Married',
    value: 'Married',
  },
  {
    label: 'Divorced',
    value: 'Divorced',
  },
  {
    label: 'Widowed',
    value: 'Widowed',
  },
];

export const STATES = [
  {
    Id: 'AA',
    Name: 'Americas excluding Canada',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'AE',
    Name: 'Europe, Middle East, Africa, and Canada',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'AK',
    Name: 'Alaska',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'AL',
    Name: 'Alabama',
    IsCommunityPropertyState: true,
  },
  {
    Id: 'AP',
    Name: 'Pacific',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'AR',
    Name: 'Arkansas',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'AS',
    Name: 'American Samoa',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'AZ',
    Name: 'Arizona',
    IsCommunityPropertyState: true,
  },
  {
    Id: 'CA',
    Name: 'California',
    IsCommunityPropertyState: true,
  },
  {
    Id: 'CO',
    Name: 'Colorado',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'CT',
    Name: 'Connecticut',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'DC',
    Name: 'District of Columbia',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'DE',
    Name: 'Delaware',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'FL',
    Name: 'Florida',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'GA',
    Name: 'Georgia',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'GU',
    Name: 'Guam',
    IsCommunityPropertyState: true,
  },
  {
    Id: 'HI',
    Name: 'Hawaii',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'IA',
    Name: 'Iowa',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'ID',
    Name: 'Idaho',
    IsCommunityPropertyState: true,
  },
  {
    Id: 'IL',
    Name: 'Illinois',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'IN',
    Name: 'Indiana',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'KS',
    Name: 'Kansas',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'KY',
    Name: 'Kentucky',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'LA',
    Name: 'Louisiana',
    IsCommunityPropertyState: true,
  },
  {
    Id: 'MA',
    Name: 'Massachusetts',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'MD',
    Name: 'Maryland',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'ME',
    Name: 'Maine',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'MI',
    Name: 'Michigan',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'MN',
    Name: 'Minnesota',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'MO',
    Name: 'Missouri',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'MP',
    Name: 'Northern Mariana Islands',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'MS',
    Name: 'Mississippi',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'MT',
    Name: 'Montana',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'NC',
    Name: 'North Carolina',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'ND',
    Name: 'North Dakota',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'NE',
    Name: 'Nebraska',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'NH',
    Name: 'New Hampshire',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'NJ',
    Name: 'New Jersey',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'NM',
    Name: 'New Mexico',
    IsCommunityPropertyState: true,
  },
  {
    Id: 'NV',
    Name: 'Nevada',
    IsCommunityPropertyState: true,
  },
  {
    Id: 'NY',
    Name: 'New York',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'OH',
    Name: 'Ohio',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'OK',
    Name: 'Oklahoma',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'OR',
    Name: 'Oregon',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'PA',
    Name: 'Pennsylvania',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'PR',
    Name: 'Puerto Rico',
    IsCommunityPropertyState: true,
  },
  {
    Id: 'RI',
    Name: 'Rhode Island',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'SC',
    Name: 'South Carolina',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'SD',
    Name: 'South Dakota',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'TN',
    Name: 'Tennessee',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'TX',
    Name: 'Texas',
    IsCommunityPropertyState: true,
  },
  {
    Id: 'UT',
    Name: 'Utah',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'VA',
    Name: 'Virginia',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'VI',
    Name: 'Virgin Islands (US)',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'VT',
    Name: 'Vermont',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'WA',
    Name: 'Washington',
    IsCommunityPropertyState: true,
  },
  {
    Id: 'WI',
    Name: 'Wisconsin',
    IsCommunityPropertyState: true,
  },
  {
    Id: 'WV',
    Name: 'West Virginia',
    IsCommunityPropertyState: false,
  },
  {
    Id: 'WY',
    Name: 'Wyoming',
    IsCommunityPropertyState: false,
  },
];
